import compose from 'recompose/compose';
import { connect } from 'react-redux';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import withHandlers from 'recompose/withHandlers';
import PromoEmailPreview from '../components/PromoEmailPreview';
import QuickUpdateEmailPreview from '../components/QuickUpdateEmailPreview';
import { CAMPAIGN_TYPE, subjectInputId } from '../constants';
import {
  activeShopName,
  activeShopNameForBarber,
  activeShopAddress,
  activeShopAddressForBarber,
} from '../../auth/selectors';
import * as promoSelectors from '../../main/settings/promoCodes/selectors';
import { setSubject, setBody } from '../actions';
import {
  getBackgroundImage,
  getLogo,
  getCampaignSubject,
  getCampaignBody,
} from '../selectors';

const EmailPreviewContainer = compose(
  connect(
    state => ({
      emailType: state.engagement.campaign.type,
      shopName: activeShopName(state) || activeShopNameForBarber(state),
      shopAddress: activeShopAddress(state) || activeShopAddressForBarber(state),
      subject: getCampaignSubject(state),
      color: state.engagement.campaign.color,
      message: getCampaignBody(state),
      backgroundImage: getBackgroundImage(state),
      logo: getLogo(state),
      promo: promoSelectors.byId(state, state.engagement.campaign.promoId) || promoSelectors.getActivePromo(state),
    }),
    {
      setSubject,
      setBody,
    },
  ),
  withHandlers({
    onSubjectChange: props => text => props.setSubject(text),
    onMessageChange: props => text => props.setBody(text),
    onSubjectClick: () => {
      const input = document.getElementById(subjectInputId);
      if (input) {
        input.focus();
      }
    },
  }),
  branch(props => props.emailType === CAMPAIGN_TYPE.update, renderComponent(QuickUpdateEmailPreview)),
)(PromoEmailPreview);

export default EmailPreviewContainer;
